import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MuComponent } from 'src/app/components/shared/types/MuComponent.componetent';
import { Flags } from 'src/app/components/shared/types/flags.type';

@Component({
  selector: 'app-new-routing-create-form',
  templateUrl: './new-routing-create-form.component.html',
  styleUrls: ['./new-routing-create-form.component.sass']
})
export class NewRoutingCreateFormComponent<FlagType> extends MuComponent {

  @Input() flagList: Flags<FlagType>;
  @Input() backToDeliveriesFlag: FlagType;
  @Input() continueToCreateServiceFlag: FlagType;
  @Input() formData: UntypedFormGroup;
  @Input() startDate: Date = new Date();
  @Input() defaultDate: Date = new Date();

  constructor() {
    super();
  }

  muOnInit(): void {
    /** */
  }

  muOnDestroy(): void {
    /** */
  }
}
